import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}
export function Select({
  className,
  label,
  children,
  ...props
}: SelectProps) {
  return <div className="flex flex-col gap-1.5" data-id="element-130">
      {label && <label className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-131">
          {label}
        </label>}
      <div className="relative" data-id="element-132">
        <select className={cn('w-full appearance-none rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500', className)} {...props} data-id="element-133">
          {children}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-500" data-id="element-134">
          <svg className="h-4 w-4 fill-current" viewBox="0 0 20 20" data-id="element-135">
            <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" data-id="element-136" />
          </svg>
        </div>
      </div>
    </div>;
}